<template lang="html">
  <div class="certificate">
    <div class="certificateContent">
      <div class="certificateHeader">
        <img src="../../assets/image/postCertificate/logo.png" alt="" class="logo">
         <h1 class="heading--primary">中国电子学会《高速PCB设计(初级)》</h1>
         <h2 class="heading--second"> 职业技能证书报名申领 </h2>
      </div>

      <div class="certificateIntroduce">
        <div class="mode">
          <div class="label">
            <div class="labelContent">
              <img src="../../assets/image/postCertificate/icon1.png" alt="">
              <span>电巢简介</span>
            </div>
          </div>
          <div class="paragraph">
            深圳市电巢科技有限公司（简称“电巢科技”）成立于2018年，是电子行业数字化赋能平台,专注于数字化技术创新的产业互联网公司。致力于利用云计算、大数据和虚拟现实等技术，推动电子产业高质量互连。电巢科技作为中国电子学会“电子信息人才能力提升工程”培训基地，学员在完成相应的课程学习后，可以通过中国电子学会官方网站进行考试认证，考试成绩合格，可获得中国电子学会认证的职业技能证书。
          </div>
        </div>

        <div class="mode">
          <div class="label">
            <div class="labelContent">
              <img src="../../assets/image/postCertificate/icon2.png" alt="">
              <span>职业技能证书价值</span>
            </div>
          </div>
          <div class="paragraph paragraphElse notice">
             <p>1、在校评优评先证明</p>
             <p>2、提升面试通过率，名企优先青睐</p>
             <p>3、掌握系统PCB产品化设计流程</p>
             <p>4、提升个人职场技能，升职加薪首选</p>
             <p>5、个人在PCB设计领域过硬技能和专业知识的强有力证明</p>
             <p>6、多领域适用，增加就业选择性（电子制造业、电子研发、电子服务及电子教育等）</p>
          </div>
        </div>

        <div class="mode">
          <div class="label">
            <div class="labelContent">
              <img src="../../assets/image/postCertificate/icon8.png" alt="">
              <span>证书申领须知</span>
            </div>
          </div>
          <div class="paragraph paragraphElse notice">
            <p>1、完成电巢岗位课程及实训项目学习的学员</p>
            <p>2、通过中国电子学会官网相关课程线上考试(60分及格)。</p>
          </div>
        </div>

        <div class="mode">
          <div class="label">
            <div class="labelContent">
              <img src="../../assets/image/postCertificate/icon3.png" alt="">
              <span>中国电子学会简介</span>
            </div>
          </div>
          <div class="paragraph paragraphElse association">
            中国电子学会成立于1962年，总部是工业和信息化部直属事业单位，是中国科协的重要组成部分。电子学会以促进电子信息科技事业的繁荣和发展，促进电子信息科学技术的普及和推广，促进电子信息科学技术人才的成长和提高，推动开放型、枢纽型、平台型科协组织建设为宗旨。职业技能证书的认证颁发，根据相关规定，可作为高技能人员考核评价、岗位聘用、职称评聘和执业注册的重要依据。
          </div>
        </div>

        <div class="contacts">
          <div class="contactWay">
            <img src="../../assets/image/postCertificate/teacher1.png" alt="">
            <p class="contactsName">证书咨询老师</p>
            <p class="contactsPhone" @click="getPhone('17778965513')">电话: <span>17778965513</span></p>
          </div>
          <div class="contactWay">
            <img src="../../assets/image/postCertificate/teacher2.png" alt="">
            <p class="contactsName">证书考前辅导老师</p>
            <p class="contactsPhone" @click="getPhone('18025439858')">电话: <span>18025439858</span></p>
          </div>
        </div>
      </div>

      <div class="certificateFooter">
        <div class="fileForBtn" @click="goFileFor">
          开始报名
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils';

  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
      }
    },

    mounted() {
      document.title = '电巢岗位实训职业技能证书';
    },

    methods: {
      getPhone(phone) {
        window.location.href = `tel:${phone}`;
      },

      goFileFor() {
        var succeedUrl = encodeURIComponent('https://edu.eda365.com/h5/m/index.html#/authenticationSucceed?aid=' + this.aid);
        if (utils.browserChecker.isWx()) {
          var channel = this.$route.query.channel || '';
          var open = encodeURIComponent('https://edu.eda365.com/h5/m/index.html#/certificateFileFor?aid=' + this.aid + '&project=activity' + '&channel=' + channel + '&succeedUrl=' + succeedUrl);
          var url = 'https://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/certificateFileFor',
            query: {
              aid: this.aid,
              channel: this.$route.query.channel || '',
              project: 'activity',
              succeedUrl: succeedUrl,
            }
          })
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  /* 头部 */
  .certificateContent {
    box-sizing: border-box;
    width: 100%;
    /* height: 151rem; */
    padding: 0 .5rem;
    background-image: url('../../assets/image/postCertificate/back1.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-color: #FECECC;
  }

  .certificateHeader {
    box-sizing: border-box;
    width: 100%;
    height: 20.7rem;
    background-image: url('../../assets/image/postCertificate/back3.png');
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .logo {
    width: 7.3rem;
    height: auto;
    margin-top: .8rem;
  }

  /* .img1 {
    width: 30.25rem;
    height: auto;
    margin-top: 1.65rem;
  }

  .img2 {
    width: 18.2rem;
    height: auto;
    margin-top: 1.2rem;
  } */

  .certificateTitle {
    width: 34.95rem;
    height: 3.7rem;
    background-image: url('../../assets/image/postCertificate/back4.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
    color: #FFFFFF;
    padding-top: .12rem;
  }

  .heading--primary {
    font-size: 2.1rem;
    color: rgb(134, 39, 28);
     margin-top: 4rem;
  }
  .heading--second {
    font-size: 2rem;
    color: rgb(249, 96, 46);
    margin-top: 2rem;
  }

  /* 介绍 */
  .certificateIntroduce {
    box-sizing: border-box;
    width: 100%;
    margin-top: -3rem;
    padding-top: 2.5rem;
    padding-left: 1.68rem;
    padding-right: 1.5rem;
    background-image: url('../../assets/image/postCertificate/back2.png');
    background-size: 100% calc(100% - 7rem);
    background-repeat: no-repeat;
    padding-bottom: 3rem;
  }

  .mode {
    box-sizing: border-box;
    padding-bottom: 1.6rem;
    margin-top: 2rem;
    border-bottom: .2rem dotted #F79E2A;
  }

  .label {
    box-sizing: border-box;
    display: inline-block;
    width: auto;
    height: 3.25rem;
    border-radius: 3.25rem;
    padding: .4rem 1.55rem;
    margin-left: .6rem;
    background: linear-gradient(#FD956D, #FF6D41);
  }

  .labelContent {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.7rem;
    color: #FFFFFF;
  }

  .labelContent img {
    width: auto;
    height: 1.8rem;
    margin-top: .15rem;
    margin-right: .33rem;
  }

  .labelContent span {
    margin-top: .25rem;
  }

  .paragraph {
    box-sizing: border-box;
    width: 100%;
    padding-left: 1.3rem;
    padding-right: 1rem;
    margin-top: 3.1rem;
    text-indent: 2em;
    font-size: 1.4rem;
    line-height: 2.4rem;
    color: #333333;
  }

  .paragraphElse {
    margin-top: 1.5rem;
  }
  
  .notice {
    text-indent: 0rem;
  }

  .association {
    padding-bottom: 2rem;
  }

  .contacts {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 0 2.2rem;

    padding-bottom: 10rem;
  }

  .contactWay {
    box-sizing: border-box;
    margin-top: 4.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contactWay img {
    width: auto;
    height: 11.8rem;
  }

  .contactsName {
    color: #333333;
    font-size: 1.4rem;
    font-weight: 600;
    margin-top: .3rem;
  }

  .contactsPhone {
    color: #333333;
    font-size: 1.4rem;
    font-weight: 600;
    margin-top: .45rem;
  }

  .contactsPhone span {
    color: #F7443F;
  }
  
  .certificateFooter {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 2rem;
    max-width: 75rem;
    width: 100%;
    padding: 0 1.2rem;
  }
  
  .fileForBtn {
    box-sizing: border-box;
    width: 100%;
    height: 5.7rem;
    line-height: 4.8rem;
    background-image: url('../../assets/image/postCertificate/back5.png');
    background-size: contain;
    background-repeat: no-repeat;
    text-align: center;
    margin-top: .3rem;
    font-size: 1.7rem;
    color: #FCFCFC;
  }

  @media (min-width: 751px) {
    .certificateFooter {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }

    .fileForBtn {
      right: 50%;
      margin-right: -375px;
    }
  }
</style>